import { Component, OnInit } from '@angular/core';

/**
 * Main loader for the timeline component
 */
@Component({
  selector: 'kmb-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
